import {
  UNIFIED_FIELD,
  UNIFIED_FIELD_HELP_CENTER_DOC,
} from '@modules/common/constants';
import { isUnifiedFieldGroupID } from '@modules/common/utils';
import { Button, Link, Typography } from '@mui/material';

interface EQLGroupFieldDescriptionTooltipContentProps {
  groupID: string;
  displayName?: string;
}

export const EQLGroupFieldDescriptionTooltipContent = ({
  groupID,
  displayName,
}: EQLGroupFieldDescriptionTooltipContentProps) => {
  if (isUnifiedFieldGroupID(groupID) || displayName === UNIFIED_FIELD) {
    return (
      <Typography variant="caption">
        Similar Fields from multiple sources merged into a single field for easy
        usage.
        <Button
          href={UNIFIED_FIELD_HELP_CENTER_DOC}
          target="_blank"
          variant="text"
          LinkComponent={Link}
          size="small"
        >
          Learn more
        </Button>
      </Typography>
    );
  }
  return null;
};
